import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { Typography } from "../../Typography/index.js";
import { Button } from "../../Button/index.js";
import { Snackbar } from "../../Snackbar/index.js";
import { useIsDesktop, useIsMobile } from "../../hooks/index.js";
const PreviewSnackbar = (t0)=>{
    const $ = c(20);
    const { open, onClick, action, message } = t0;
    const isDesktop = useIsDesktop();
    const isMobile = useIsMobile();
    let t1;
    if ($[0] !== isMobile || $[1] !== message || $[2] !== open) {
        t1 = isMobile && message && /*#__PURE__*/ jsx(Snackbar, {
            open: open,
            message: /*#__PURE__*/ jsx(Typography, {
                variant: "subtitle1",
                color: "text.dark.primary",
                children: message
            }),
            action: null,
            zPosition: "top"
        });
        $[0] = isMobile;
        $[1] = message;
        $[2] = open;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== isMobile || $[5] !== message) {
        t2 = !isMobile && /*#__PURE__*/ jsx(Typography, {
            variant: "h6",
            color: "text.dark.primary",
            children: message
        });
        $[4] = isMobile;
        $[5] = message;
        $[6] = t2;
    } else t2 = $[6];
    const t3 = isMobile ? "medium" : "large";
    const t4 = action || "\u0417\u0430\u043A\u0440\u044B\u0442\u044C";
    let t5;
    if ($[7] !== isMobile || $[8] !== onClick || $[9] !== t3 || $[10] !== t4) {
        t5 = /*#__PURE__*/ jsx(Button, {
            onClick: onClick,
            size: t3,
            fullWidth: isMobile,
            children: t4
        });
        $[7] = isMobile;
        $[8] = onClick;
        $[9] = t3;
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    const t6 = isDesktop ? "static" : "sticky";
    let t7;
    if ($[12] !== open || $[13] !== t2 || $[14] !== t5 || $[15] !== t6) {
        t7 = /*#__PURE__*/ jsx(Snackbar, {
            open: open,
            message: t2,
            action: t5,
            className: "aqa_file_preview_snackbar",
            variant: t6,
            zPosition: "bottom"
        });
        $[12] = open;
        $[13] = t2;
        $[14] = t5;
        $[15] = t6;
        $[16] = t7;
    } else t7 = $[16];
    let t8;
    if ($[17] !== t1 || $[18] !== t7) {
        t8 = /*#__PURE__*/ jsxs(Fragment, {
            children: [
                t1,
                t7
            ]
        });
        $[17] = t1;
        $[18] = t7;
        $[19] = t8;
    } else t8 = $[19];
    return t8;
};
export { PreviewSnackbar };
